import React from 'react';
import { Star } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
const testimonials = [{
  name: 'Camila M.',
  location: 'Buenos Aires',
  role: 'Mamá y celíaca',
  text: 'Antes no sabía qué cocinar y terminaba comiendo siempre lo mismo. Ahora tengo recetas simples, saludables y organizadas para toda la semana.'
}, {
  name: 'Lucas R.',
  location: 'Rosario',
  role: 'Vida saludable sin gluten',
  text: 'Las planillas y horarios me ayudaron muchísimo. Dejé de improvisar comidas y mi digestión mejoró un montón.'
}, {
  name: 'Valentina F.',
  location: 'Córdoba',
  role: 'Alimentación consciente',
  text: 'Pensaba que comer sin gluten era aburrido. Este sistema me mostró opciones fáciles, ricas y prácticas para todos los días.'
}];
export function Testimonials() {
  return <section className="py-16 bg-white relative" data-id="element-219">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-220">
        <div className="grid md:grid-cols-3 gap-8" data-id="element-221">
          {testimonials.map((testimonial, idx) => <FadeIn key={idx} delay={idx * 0.15} className="bg-cream-200 p-8 rounded-3xl shadow-soft" data-id="element-222">
              <div className="flex gap-1 mb-4" data-id="element-223">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-brand-500 text-brand-500" data-id="element-224" />)}
              </div>
              <p className="text-brand-900 text-lg mb-6 italic font-medium leading-relaxed" data-id="element-225">
                "{testimonial.text}"
              </p>
              <div data-id="element-226">
                <p className="font-bold text-brand-950" data-id="element-227">{testimonial.name}</p>
                <p className="text-sm text-brand-600" data-id="element-228">
                  {testimonial.location} — {testimonial.role}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}